import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 4,
  cy: 14,
  r: 3
});

var SvgPipeline = function SvgPipeline(props) {
  return _ref;
};

export default SvgPipeline;